// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orders_OrderItemStepsResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /so/orders/order_item_steps/{order_item_id}.
 *
 * Returns the list of work-order steps for the item's work order.
 */
import type { Orders_WorkOrderStepRow } from './Orders_WorkOrderStepRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Orders_OrderItemStepsResponseDados = Orders_WorkOrderStepRow[];

export type Orders_OrderItemStepsResponse = ApiResponse<Orders_OrderItemStepsResponseDados>;

registerResponseContract('Orders_OrderItemStepsResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      so_work_order_step_id:                 { type: 'number',  required: true },
      so_work_order_step_work_order_id:      { type: 'number',  required: true },
      so_work_order_step_production_step_id: { type: 'number',  required: true },
      so_work_order_step_name:               { type: 'string',  required: true },
      so_work_order_step_order:              { type: 'number',  required: true },
      so_work_order_step_status:             { type: 'string',  required: true },
      so_work_order_step_started_at:         { type: 'string',  required: false },
      so_work_order_step_completed_at:       { type: 'string',  required: false },
      so_work_order_step_assignee_user_id:   { type: 'string',  required: false },
      so_work_order_step_notes:              { type: 'string',  required: false },
      so_work_order_step_source:             { type: 'string',  required: true },
      so_work_order_step_order_item_id:      { type: 'number',  required: false },
      so_work_order_step_created_at:         { type: 'string',  required: true },
      so_work_order_step_was_resumed:        { type: 'number',  required: false },
    },
  },
})
